import React from 'react';
import Helmet from "react-helmet";

export default ({ children }) => (
    <div>
      <div id="fb-root"/>
      <Helmet>
        <script async defer crossOrigin="anonymous" src="https://connect.facebook.net/it_IT/sdk.js#xfbml=1&version=v8.0"
                nonce="XMkqIhlE"/>
      </Helmet>
      <div className="fb-page rounded shadow my-4" data-href="https://www.facebook.com/DPCgov/" data-tabs="timeline"
           data-width="370" data-height="400" data-small-header="false" data-adapt-container-width="true"
           data-hide-cover="false" data-show-facepile="false">
        <blockquote cite="https://www.facebook.com/DPCgov/" className="fb-xfbml-parse-ignore"><a
            href="https://www.facebook.com/DPCgov/">Dipartimento Protezione Civile</a></blockquote>
      </div>
    </div>

);
